(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function initPopup(popup) {
    var cookieName = 'popup-club-dismissed-' + popup.id;
    var dismissDays = parseInt(popup.getAttribute('data-dismiss-days'), 10) || 7;
    var delaySeconds = parseFloat(popup.getAttribute('data-delay')) || 0;
    var triggerMode = popup.getAttribute('data-trigger-mode') || 'manual';
    var closeTriggers = popup.querySelectorAll('[data-popup-club-close]');
    var lastFocused = null;

    function openPopup() {
      lastFocused = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = popup.querySelector('.popup-club__close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (triggerMode === 'automatic') {
        setCookie(cookieName, '1', dismissDays);
      }
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    }

    closeTriggers.forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    // Botones en cualquier parte de la página que abren ESTE popup.
    // Uso: <button data-popup-club-open="popup-club-{{ section.id }}">Abrir</button>
    // o simplemente: <button class="popup-club-trigger">Abrir</button> (si solo hay un popup en la página)
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-popup-club-open], .popup-club-trigger');
      if (!trigger) return;

      var targetId = trigger.getAttribute('data-popup-club-open');
      var matchesThisPopup = !targetId || targetId === '' || targetId === popup.id;

      if (matchesThisPopup) {
        event.preventDefault();
        openPopup();
      }
    });

    // Modo automático: solo se auto-abre si el navegador no lo ha cerrado antes (cookie).
    if (triggerMode === 'automatic' && !getCookie(cookieName)) {
      window.setTimeout(openPopup, delaySeconds * 1000);
    }
  }

  function init() {
    var popups = document.querySelectorAll('[data-popup-club]');
    popups.forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
